import React, { Component } from 'react'
import { Link } from 'react-router';
import { Row, Col } from 'reactstrap';
import { FieldCol, FieldGroup, FieldLabel, FieldSelect, FieldInput, FieldTextarea, FieldDate } from '../../Elements';
import {days, emailRegx, } from '../../../../constants';
import { titanInstance ,gaTelesisInstance, avationPlcInstance, mtInstance, leshaBankInstance, hanwahaInstance} from '../../../../shared_elements/components';
import { globalGetService } from '../../../../globalServices';
import { checkApiStatus } from '../../../../utils_v2';
import { Creatable } from 'react-select';
import { jetStreamInstance } from '../../../../lease_management/Leases';

export default class EditReserveConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mrRateInvoiceInfo: {},
            bankList:[]
        }
    }
    componentDidMount() {
        let data = this.props.mrRateInvoiceInfo
        data = { ...data, reserve_account_emails: data?.reserve_account_emails ? data.reserve_account_emails.map(email => { return { label: email, value: email } }) : [] }
        this.setState({
            mrRateInvoiceInfo: data
        });
        this.getBankList()
    }


    updateForm = (type, value) => {
        if(['pledged', 'correction_non_business_days', 'mr_payment_obligation', 'interest_accrual', 'due_date','industry_experience','remark_date','reserve_qis_number','reserve_sales_order_number','reporting_frequency'].includes(type)){
            this.setState(prevState => ({
                ...prevState,
                mrRateInvoiceInfo: {
                  ...prevState.mrRateInvoiceInfo,
                  reserve_account_titan_extra_fields: {
                    ...prevState.mrRateInvoiceInfo.reserve_account_titan_extra_fields,
                    [type]: value
                  }
                }
              }))
        } else if (type === 'mr_invoice_is_due_day_last_day_month' && jetStreamInstance) {
            this.setState(prevState => ({
                ...prevState,
                mrRateInvoiceInfo: {
                    ...prevState.mrRateInvoiceInfo,
                    mr_invoice_is_due_day_last_day_month: value,
                    mr_invoice_due_day_of_month: null
                }
            }));
        }else{
            this.setState(prevState => ({
                ...prevState,
                mrRateInvoiceInfo: {
                    ...prevState.mrRateInvoiceInfo,
                    [type]: value
                }
            }))
        }
    }
  getBankList() {
        globalGetService(`console/bank-details/`, { dropdown: true, contract_id:this.props?.mrRateInvoiceInfo?.id })
            .then(response => {
                if (checkApiStatus(response)) {
                    this.setState({ bankList: response.data.data })
                }
            })
    }
    
    contrInvcInfoEdit = (e) => {
        e.preventDefault();
        const {mrRateInvoiceInfo}= this.state
        let payload ={
            reserve_default_bank:mrRateInvoiceInfo?.reserve_default_bank || null,
            mr_invoice_day_of_month: mrRateInvoiceInfo.mr_invoice_day_of_month ? mrRateInvoiceInfo.mr_invoice_day_of_month : null,
            mr_invoice_due_day_of_month: mrRateInvoiceInfo.mr_invoice_due_day_of_month ? mrRateInvoiceInfo.mr_invoice_due_day_of_month : null, 
            mr_invoice_is_due_day_next_month: mrRateInvoiceInfo.mr_invoice_is_due_day_next_month,
           
        }
        if(titanInstance || avationPlcInstance || mtInstance || leshaBankInstance){
                    payload = {...payload, remarks : mrRateInvoiceInfo.remarks_reserve, reference_number :mrRateInvoiceInfo.reference_number_reserve,reserve_account_emails: mrRateInvoiceInfo?.reserve_account_emails ?mrRateInvoiceInfo?.reserve_account_emails?.map(email => email.value) : [],                reserve_account_titan_extra_fields: {
                    ...mrRateInvoiceInfo.reserve_account_titan_extra_fields,
                    pledged: mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.pledged,
                    correction_non_business_days: mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.correction_non_business_days,
                    mr_payment_obligation: mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.mr_payment_obligation,
                    interest_accrual: mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.interest_accrual,
                    due_date: mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.due_date,
                    remark_date: mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.remark_date
                }
              }
        }else if(gaTelesisInstance){
            payload = {...payload, 
                reference_number :mrRateInvoiceInfo.reference_number_reserve ,
                reserve_account_titan_extra_fields :{
                reserve_qis_number : mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reserve_qis_number ||null,
                reserve_sales_order_number : mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reserve_sales_order_number || null
                }
            }
        } else if (jetStreamInstance) {
                    payload = {
                        ...payload,
                        mr_invoice_is_due_day_last_day_month: mrRateInvoiceInfo?.mr_invoice_is_due_day_last_day_month
                    }
        } else if (hanwahaInstance) {
            payload = {
                ...payload,
                reserve_account_code: mrRateInvoiceInfo.reserve_account_code
            }
        }
        this.props.contrInvcInfoEdit(payload);
    }

    onChange = (emails, fieldName) => {
        const emailList = emails.filter(email => emailRegx.test(email.value));
        this.setState(prevState => ({
            ...prevState,
            mrRateInvoiceInfo: {
                ...prevState.mrRateInvoiceInfo,
                [fieldName]: emailList
            },
            error: {
                ...prevState.error,
                [fieldName]: ''
            }
        }));
    }

    render() {
        const { mrRateInvoiceInfo, bankList } = this.state;
        const { type } = this.props;
        return (
            <form onSubmit={(e) => this.contrInvcInfoEdit(e)}>
                <div style={{ height: (window.innerHeight - 157) + 'px', overflow: 'auto', marginBottom: '60px' }}>
                    <Row>
                        <FieldCol md="12">
                            <FieldGroup className="form-group" >
                                <FieldLabel className="label">Invoice Generation Day ( For Every Month )</FieldLabel>
                                <FieldSelect
                                    placeholder='Select Day'
                                    keyParam="mr_invoice_day_of_month"
                                    value={mrRateInvoiceInfo.mr_invoice_day_of_month}
                                    type={type}
                                    options={days}
                                    updateField={this.updateForm}
                                    labelKey='label'
                                    valueKey='value'
                                />
                            </FieldGroup>
                        </FieldCol>
                        <FieldCol md="12">
                            <FieldGroup className="form-group" >
                                <FieldLabel className="label">Invoice Due Day ( For Every Month )</FieldLabel>
                                <FieldSelect
                                    placeholder='Select Day'
                                    keyParam="mr_invoice_due_day_of_month"
                                    value={mrRateInvoiceInfo.mr_invoice_due_day_of_month}
                                    disabled={mrRateInvoiceInfo.mr_invoice_is_due_day_last_day_month===true}
                                    type={type}
                                    options={days}
                                    updateField={this.updateForm}
                                    labelKey='label'
                                    valueKey='value'
                                />
                            </FieldGroup>
                        </FieldCol>
                        <Col md="12">
                            <div className="form-group" >
                                <label className="label">
                                    <input type="checkbox" name="mr-invoice" checked={mrRateInvoiceInfo.mr_invoice_is_due_day_next_month} onChange={(e) => this.updateForm('mr_invoice_is_due_day_next_month', e.target.checked)} />
                                    <span> Invoice Due Day falls in next Month</span>
                                </label>
                            </div>
                        </Col>
                        {jetStreamInstance ?
                            <Col md="12">
                                <div className="form-group" >
                                    <label className="label">
                                        <input type="checkbox" name="mr-invoice" checked={mrRateInvoiceInfo.mr_invoice_is_due_day_last_day_month} onChange={(e) => this.updateForm('mr_invoice_is_due_day_last_day_month', e.target.checked)} />
                                        <span>Invoice Due Day falls at last day of the Billing Month</span>
                                    </label>
                                </div>
                            </Col>:null
                        }
                        <FieldCol md="12">
                            <FieldGroup className="form-group" >
                                <FieldLabel className="label">Default Bank </FieldLabel>
                                <FieldSelect
                                    placeholder='Select Day'
                                    keyParam="reserve_default_bank"
                                    value={mrRateInvoiceInfo.reserve_default_bank}
                                    type={type}
                                    options={bankList}
                                    updateField={this.updateForm}
                                    labelKey='name'
                                    valueKey='id'
                                />
                            </FieldGroup>
                        </FieldCol>
                        {hanwahaInstance ?
                            <FieldCol md="12">
                                <FieldGroup className="form-group">
                                    <FieldLabel className="label">
                                        Account Code
                                    </FieldLabel>
                                    <FieldInput
                                        value={mrRateInvoiceInfo?.reserve_account_code || ''}
                                        type={type}
                                        keyParam="reserve_account_code"
                                        updateField={this.updateForm}
                                        maxLength={5}
                                    />
                                    <h6 className="error-msg">{''}</h6>
                                </FieldGroup>
                            </FieldCol> : null
                        }
                        {(titanInstance || gaTelesisInstance || avationPlcInstance || mtInstance || leshaBankInstance) ? <FieldCol md="12">
                            <FieldGroup className="form-group">
                                <FieldLabel className="label">
                                    Reference Number
                                </FieldLabel>
                                <FieldInput
                                    value={mrRateInvoiceInfo.reference_number_reserve ? mrRateInvoiceInfo.reference_number_reserve : ''}
                                    type={type}
                                    keyParam="reference_number_reserve"
                                    updateField={this.updateForm}
                                    maxLength={(titanInstance||avationPlcInstance||mtInstance||leshaBankInstance) ?50 : 250}
                                />
                                <h6 className="error-msg">{''}</h6>
                            </FieldGroup>
                        </FieldCol> : null}
                        { gaTelesisInstance ?<>
                        <FieldCol md="12">
                            <FieldGroup className="form-group">
                                <FieldLabel className="label">
                                    QIS Number                                
                                </FieldLabel>
                                <FieldInput
                                    value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reserve_qis_number ? mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reserve_qis_number : ''}
                                    type={type}
                                    keyParam="reserve_qis_number"
                                    updateField={this.updateForm}
                                    maxLength={ 250}
                                />
                                <h6 className="error-msg">{''}</h6>
                            </FieldGroup>
                        </FieldCol> 
                        <FieldCol md="12">
                            <FieldGroup className="form-group">
                                <FieldLabel className="label">
                                  Sales Order Number                                
                                </FieldLabel>
                                <FieldInput
                                    value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reserve_sales_order_number ? mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reserve_sales_order_number : ''}
                                    type={type}
                                    keyParam="reserve_sales_order_number"
                                    updateField={this.updateForm}
                                    maxLength={250}
                                />
                                <h6 className="error-msg">{''}</h6>
                            </FieldGroup>
                        </FieldCol></> : null}
                        {(titanInstance || avationPlcInstance || mtInstance || leshaBankInstance) ? 
                        <>
                        <FieldCol md="12">
                            <FieldGroup className="form-group" >
                                <FieldLabel className="label">Remarks</FieldLabel>
                                <FieldTextarea
                                    value={mrRateInvoiceInfo.remarks_reserve ? mrRateInvoiceInfo.remarks_reserve : ""}
                                    type={type}
                                    keyParam="remarks_reserve"
                                    updateField={this.updateForm}
                                    maxLength={500}
                                />
                            </FieldGroup>
                        </FieldCol>
                                <FieldCol md="12">
                                    <FieldGroup className="form-group" >
                                        <FieldLabel className="label">
                                            Remark Date
                                        </FieldLabel>
                                        <FieldDate
                                            value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.remark_date}
                                            type={type}
                                            keyParam="remark_date"
                                            updateField={this.updateForm}
                                            disable={type == 'view' ? true : false}
                                        />
                                    </FieldGroup>
                                </FieldCol> 
                                {(avationPlcInstance||mtInstance||leshaBankInstance)?<>
                                <FieldCol md="12">
                                    <FieldGroup className="form-group" >
                                        <FieldLabel className="label">
                                            Pledged
                                        </FieldLabel>
                                        <FieldInput
                                            value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.pledged}
                                            type={type}
                                            keyParam="pledged"
                                            updateField={this.updateForm}
                                            disable={type == 'view' ? true : false}
                                        />
                                    </FieldGroup>
                                </FieldCol>
                                <FieldCol md="12">
                                    <FieldGroup className="form-group" >
                                        <FieldLabel className="label">
                                            Correction For Non Business Days
                                        </FieldLabel>
                                        <FieldInput
                                            value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.correction_non_business_days}
                                            type={type}
                                            keyParam="correction_non_business_days"
                                            updateField={this.updateForm}
                                            disable={type == 'view' ? true : false}
                                        />
                                    </FieldGroup>
                                </FieldCol></>:null}
                                <FieldCol md="12">
                                    <FieldGroup className="form-group" >
                                        <FieldLabel className="label">
                                            MR Payment Obligation
                                        </FieldLabel>
                                        <FieldInput
                                            value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.mr_payment_obligation}
                                            type={type}
                                            keyParam="mr_payment_obligation"
                                            updateField={this.updateForm}
                                            disable={type == 'view' ? true : false}
                                        />
                                    </FieldGroup>
                                </FieldCol>
                                {(avationPlcInstance||mtInstance||leshaBankInstance)?<>
                                <FieldCol md="12">
                                    <FieldGroup className="form-group" >
                                        <FieldLabel className="label">
                                            Interest Accrual
                                        </FieldLabel>
                                        <FieldInput
                                            value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.interest_accrual}
                                            type={type}
                                            keyParam="interest_accrual"
                                            updateField={this.updateForm}
                                            disable={type == 'view' ? true : false}
                                        />
                                    </FieldGroup>
                                </FieldCol>
                                <FieldCol md="12">
                                        <FieldGroup className="form-group">
                                            <FieldLabel className="label">Invoice/Reporting Frequency</FieldLabel>
                                            <FieldSelect
                                                placeholder='Select Reporting Frequency'
                                                keyParam="reporting_frequency"
                                                value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.reporting_frequency}
                                                type={type}
                                                options={[{ label: 'Monthly', value: 'Monthly' }, { label: 'Quarterly', value: 'Quarterly' }, { label: 'Yearly', value: 'Yearly' }]}
                                                updateField={this.updateForm}
                                                labelKey='label'
                                                valueKey='value'
                                            />
                                        </FieldGroup>
                                </FieldCol></>:null}
                                <FieldCol md="12">
                                    <FieldGroup className="form-group" >
                                        <FieldLabel className="label">
                                            Invoice Date
                                        </FieldLabel>
                                        <FieldDate
                                            value={mrRateInvoiceInfo?.reserve_account_titan_extra_fields?.due_date}
                                            type={type}
                                            keyParam="due_date"
                                            updateField={this.updateForm}
                                            disable={type == 'view' ? true : false}
                                        />
                                    </FieldGroup>
                                </FieldCol></>
                        : null} 
                        {titanInstance ?
                            <FieldCol md="12">
                                <FieldGroup className="form-group">
                                    <FieldLabel className="label">Email CC</FieldLabel>
                                    <Creatable
                                        value={mrRateInvoiceInfo?.reserve_account_emails}
                                        onChange={(emails) => this.onChange(emails, 'reserve_account_emails')}
                                        className="custom-select-block"
                                        placeholder="Enter CC Email(s)"
                                        multi={true}
                                        noResultsText="Type New Email Address"
                                    />
                                    {/* <h6 className="error-msg">{error.cc_address}</h6> */}
                                </FieldGroup>
                            </FieldCol> : null} 
                    </Row>
                </div>
                <div className="submit-block">
                    <input type="submit" className="primary-btn" value="Save Changes" />
                    <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
                </div>
            </form>
        )
    }
}
